import { render, staticRenderFns } from "./CreateUpdateMsVar.vue?vue&type=template&id=09e56581&scoped=true"
import script from "./CreateUpdateMsVar.vue?vue&type=script&lang=js"
export * from "./CreateUpdateMsVar.vue?vue&type=script&lang=js"
import style0 from "./CreateUpdateMsVar.vue?vue&type=style&index=0&id=09e56581&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e56581",
  null
  
)

export default component.exports